import React from 'react'

import HeroZones from '../Views/Home/HeroZones'

const zones = [
  {
    key: 'hero-1',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      src: '/bigAssets/foam_1.png',
      smallSrc: '/bigAssets/foam_1_small.png',
      justification: 'CENTER',
      width: 'NARROW'
    }
  },
  {
    key: 'hero-2',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      h: [
        'Foam is excited to announce the launch of Trust Zone, the Foam Location incentivized testnet.'
      ],
      justification: 'LARGE',
      width: 'WIDE'
    }
  },
  {
    key: 'hero-3',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      h4: ['FOAM Location Testnet'],
      p: [
        <br key="br1" />,
        'Trust Zone is the program where Location Service Providers can operate Zones, complete tasks, and provide feedback to improve FOAM Location.',
        <br key="br2" />,
        <br key="br3" />,
        'FOAM Location is a permissionless and autonomous network of radios that offer secure location services through time synchronization, independent of centralized sources like GPS.',
        <br key="br4" />,
        <br key="br5" />,
        'The goal of Trust Zone is to run FOAM Location in different geographical environments, test various zone configurations and the current prototype of the FOAM radio. The participants will have to run localization experiments and submit the results for evaluation.'
      ],
      justification: 'CENTER',
      width: 'NARROW'
    }
  },
  {
    key: 'hero-7-B',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    size: 'wide',
    image: {
      src: '/bigAssets/foam-full-1.jpg',
      smallSrc: '/bigAssets/foam-full-1-s.jpg'
    }
  },
  {
    key: 'hero-4',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      h4: ['Why participate?'],
      p: [
        <br key="br1" />,
        <span className="outline" key="span1">
          Refine Localization in real world
        </span>,
        'You will have a key role in the development of the protocol and features while helping to refine localization results.',
        <span className="outline" key="span2">
          Earn Rewards
        </span>,
        'As a partner participant in the Trust Zone program you will be eligible for earning FOAM tokens.',
        <span className="outline" key="span3">
          Be the First Zone Operator
        </span>,
        'You will be the first Zone Operator when the network further opens to stake, earn mining rewards and offer location services to customers. '
      ],
      justification: 'CENTER',
      width: 'NARROW'
    }
  },
  {
    key: 'hero-5',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      button: ['Sign up'],
      justification: 'CENTER',
      width: 'WIDE'
    }
  },
  {
    key: 'hero-6',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      h4: ['Zone Anchors'],
      p: [
        <br key="br1" />,
        'The decentralized FOAM Location network consists of Zone Anchors (ZA). These remotely-controlled radio nodes are coordinated to transceive LoRa packets to and from one another and configured to log those packets to a remote data store such as blockchain.',
        <br key="br2" />,
        <br key="br3" />,
        'The Zone Anchor consists of the PCB stack, battery, LTE Modem, and two antennas. To perform localization, the ZA needs to be placed outdoors. For the early stage of the program, a radio node assembled from off-the-shelf components will be used.',
        <br key="br4" />,
        <br key="br5" />,
        'The Zone Anchor with custom-designed hardware and enclosure is under development.'
      ],
      justification: 'CENTER',
      width: 'NARROW'
    }
  },
  {
    key: 'hero-7',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    size: 'wide',
    image: {
      src: '/bigAssets/foam_3.png',
      smallSrc: '/bigAssets/foam_3_small.png'
    }
  },
  {
    key: 'hero-8',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      h4: ['Trust Zone'],
      p: [
        <br key="br1" />,
        'The FOAM Location protocol requires at least four Zone Anchor radios to form a zone. Program participants would need to scope and test locations for all four radios.',
        <br key="br2" />,
        <br key="br3" />,
        'After the radio nodes are set up, a visibility test would need to be performed to assess the viability of the location. Material and support will be provided on how to approach building owners to allow permission to use their building. Once permanently installed, your Zone will be up and running and eligible for participating in multiple kinds of location tracking use cases and stress testing of the protocol. '
      ],
      justification: 'CENTER',
      width: 'NARROW'
    }
  },
  {
    key: 'hero-9',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    slider: {
      width: 'narrow',
      images: [
        '/bigAssets/foam-g-1.jpg',
        '/bigAssets/foam-g-2.jpg',
        '/bigAssets/foam-g-3.jpg',
        '/bigAssets/foam-g-4.jpg'
      ],
      smallImages: [
        '/bigAssets/foam-g-1-s.jpg',
        '/bigAssets/foam-g-2-s.jpg',
        '/bigAssets/foam-g-3-s.jpg',
        '/bigAssets/foam-g-4-s.jpg'
      ],
      captions: ['Zone Anchor product under development']
    }
  },
  {
    key: 'hero-10',
    component: HeroZones,
    color: 'DARK',
    shadow: false,
    main: {
      h4: [
        'Brooklyn Navy Yard Zone &',
        <br key="br1" />,
        'Current Zone Anchor prototype'
      ],
      justification: 'CENTER',
      width: 'NARROW-MINIMAL'
    }
  },
  {
    key: 'hero-11',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    slider: {
      width: 'full',
      images: [
        '/bigAssets/foam-bk-1.png',
        '/bigAssets/foam-bk-2.png',
        '/bigAssets/foam-bk-3.png',
        '/bigAssets/foam-bk-4.png',
        '/bigAssets/foam-bk-5.png',
        '/bigAssets/foam-bk-6.png'
      ],
      smallImages: [
        '/bigAssets/foam-bk-1-s.png',
        '/bigAssets/foam-bk-2-s.png',
        '/bigAssets/foam-bk-3-s.png',
        '/bigAssets/foam-bk-4-s.png',
        '/bigAssets/foam-bk-5-s.png',
        '/bigAssets/foam-bk-6-s.png'
      ],
      captions: [
        'localization algorithm data',
        'network simulation on Raspberry Pis'
      ]
    }
  },
  {
    key: 'hero-12',
    component: HeroZones,
    color: 'DARK',
    shadow: false,
    main: {
      h4: [],
      p: [
        <br key="br1" />,
        'The first operational Zone is deployed at ',
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://brooklynnavyyard.org/"
          key="a1"
        >
          Brooklyn Navy Yard(BNY)
        </a>,
        ' to test in a dense, urban setting and serves as an ongoing sandbox environment since June 2020. The installation hosts four radio nodes (Zone Anchors) across three rooftops with good visibility between them. Unlike tests done in an ideal environment such as an open field, the BNY installation has radio nodes at different altitudes that range from 10m to 60m, and the largest distance between them is 1000m.',
        <br key="br2" />,
        <br key="br3" />,
        'The radio nodes currently tested are the latest developer prototypes assembled from off-the-shelf components provisioned through a remote management system developed at FOAM. The daily experiments include localization of the static nodes on the rooftops one by one as well as a dynamic moving node, which we do with a person walking with a radio node as well as on bicycles and vehicles.',
        <br key="br4" />,
        <br key="br5" />
      ],
      a: [
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://blog.foam.space/foam-2020-summer-updates-7c78cbd5fdca"
          key="a2"
        >
          Read More
        </a>
      ],
      justification: 'CENTER',
      width: 'NARROW'
    }
  },
  {
    key: 'hero-13',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    main: {
      button: ['Sign up'],
      justification: 'CENTER',
      width: 'WIDE'
    }
  },
  {
    key: 'hero-14',
    component: HeroZones,
    color: 'LIGHT',
    shadow: false,
    video: {
      hidePlayBtn: false,
      hidePauseBtn: true,
      src: '/bigAssets/foam_final_vid.mp4',
      alt: ''
    }
  }
]

export { zones }



// WEBPACK FOOTER //
// ./src/content/homePageZones.js